export default __webpack_public_path__ + "static/media/add_item.ea69b56b.svg";